<template>
	<!-- Vue Material Select -->
	<!-- https://vuematerial.io/components/select -->

	<md-field :class="{ 'md-invalid': errorMessage }">
		<label v-if="label">{{ label }}</label>
		<md-select
			:disabled="disabled"
			:multiple="multiple"
			:required="required"
			:value="value"
			@input="$emit('input', $event)"
			@md-opened="$emit('open')"
			@md-selected="$emit('select', $event)"
		>
			<slot/>
		</md-select>
		<span v-if="errorMessage" class="md-error">{{ errorMessage }}</span>
	</md-field>
</template>

<script>
import UiValidator from "lib/components/ui/Validator";

export default {
	name: "Select",
	mixins: [UiValidator],
	props: {
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		},
		multiple: {
			type: Boolean,
			default: false,
			required: false
		},
		required: {
			type: Boolean,
			default: false,
			required: false
		},
		value: {
			type: [String, Number, Array],
			default: "",
			required: false
		}
	},
	watch: {
		required() {
			this.validate();
		},
		value() {
			this.validate();
		}
	},
	methods: {
		_validate() {
			if (this.required && (this.value === null || this.value.length === 0))
				return `${this.label} must be selected`;

			return null;
		}
	}
};
</script>
